import { InjectionToken } from '@angular/core';

export interface AnalyticsConfig {
  /**
   * PostHog project API key (e.g. `phc_xxx`). Leave empty to disable analytics.
   */
  posthogKey: string;

  /**
   * PostHog ingestion host. Use `https://us.i.posthog.com`, `https://eu.i.posthog.com`,
   * or your self-hosted URL.
   */
  posthogHost: string;

  /**
   * Optional environment label sent as a super-property with every event
   * (e.g. `production`, `staging`, `development`). Useful for filtering in PostHog.
   */
  environment?: string;
}

export const ANALYTICS_CONFIG = new InjectionToken<AnalyticsConfig>('ANALYTICS_CONFIG');
